import React from "react"
import PropTypes from "prop-types"
import DateMaskedInput from "./masked-date-input"
import CpfCnpjMaskedInput from "./masked-cpf-cnpj-input"
import GenericMaskedInput from "./masked-generic-input"
import TextFieldInput from "../text-field-input"

const DecimalInput = ({onChange, inputProps, ...rest}) => {
    const handleChange = (event) => {
        const raw = event.target.value || ""
        const normalizedRaw = raw.replace(/,/g, ".").replace(/[^\d.]/g, "")
        const [intPart, ...restParts] = normalizedRaw.split(".")
        const cleaned = restParts.length ? `${intPart}.${restParts.join("")}` : intPart
        onChange?.({
            ...event,
            target: {
                ...event.target,
                value: cleaned,
            },
        })
    }

    const mergedInputProps = {inputMode: "decimal", ...(inputProps || {})}

    return <TextFieldInput {...rest} onChange={handleChange} inputProps={mergedInputProps} />
}

DecimalInput.propTypes = {
    onChange: PropTypes.func,
    inputProps: PropTypes.object,
}

const IntegerInput = ({onChange, inputProps, ...rest}) => {
    const handleChange = (event) => {
        const raw = event.target.value || ""
        const cleaned = raw.replace(/\D/g, "")
        onChange?.({
            ...event,
            target: {
                ...event.target,
                value: cleaned,
            },
        })
    }

    const mergedInputProps = {inputMode: "numeric", pattern: "[0-9]*", ...(inputProps || {})}

    return (
        <TextFieldInput
            {...rest}
            onChange={handleChange}
            inputProps={mergedInputProps}
        />
    )
}

IntegerInput.propTypes = {
    onChange: PropTypes.func,
    inputProps: PropTypes.object,
}

const MaskedTextFieldInput = ({maskType, mask, minDate, maxDate, ...rest}) => {
    if (maskType === "date") {
        return <DateMaskedInput minDate={minDate} maxDate={maxDate} {...rest} />
    }

    if (maskType === "cpf" || maskType === "cnpj" || maskType === "cpfCnpj") {
        return <CpfCnpjMaskedInput {...rest} maskType={maskType} />
    }

    if (maskType === "decimal") {
        return <DecimalInput {...rest} />
    }

    if (maskType === "integer") {
        return <IntegerInput {...rest} />
    }

    if (mask) {
        return <GenericMaskedInput mask={mask} {...rest} />
    }

    return <TextFieldInput {...rest} />
}

MaskedTextFieldInput.propTypes = {
    maskType: PropTypes.oneOf(["date", "cpf", "cnpj", "cpfCnpj", "decimal", "integer"]),
    mask: PropTypes.string,
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
}

export default MaskedTextFieldInput
